import { Directive, HostListener, ElementRef, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appTrimOnPaste]'
})
export class TrimOnPasteDirective {
  constructor(private el: ElementRef, @Optional() @Self() private ngControl: NgControl) {}

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    if (event.clipboardData) {
      const pastedText = event.clipboardData.getData('text/plain').trim();
      this.el.nativeElement.value = pastedText; // Update the input's value
      if (this.ngControl?.control) {
        this.ngControl.control.setValue(pastedText); // Update the ngModel value if ngControl is not null
      }
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) onInput(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value.replace(/(\s{2,})/g, ' ').replace(/^\s+/, '');
    const trimmedString = this.trimSpecialCharacters(inputValue, "*\/\_\&\^\%\$\#\@\!\+\=\`\~");
    // const inputValue = inputElement.value.replace(/^\s+|[^a-zA-Z0-9.,\/\-]+/g, '');
    this.el.nativeElement.value = trimmedString;
    if (this.ngControl?.control) {
      this.ngControl.control.setValue(trimmedString);
    }
    event.preventDefault();
  }

  trimSpecialCharacters(input: string, characters: string): string {
    const regex = new RegExp(`^[${characters}]+|[${characters}]+$`, 'g');
    return input.replace(regex, '');
  }

}
